import React from 'react';
import { getIntl } from '../../../../utils/intl';
import { FormStack } from '../../../v2BaseComponents/Stack';
import { SplitFormRow } from '../../../v2BaseComponents/Form';
import { Field } from 'formik';
import { FormikInputs } from '../../../v2BaseComponents/Inputs';
import { composeValidators, email, required } from '../../../../utils/validators';
import { OrganizationUserRole } from '../../../../primary-record-types/OrganizationTypes';
import { SelectOption } from '../../../v2BaseComponents/Inputs/Select/types';
import { organizationRoles } from '../../../../utils/sharedMessages';

const intl = getIntl('OrganizationInvitation-fields', {
    email: 'Email',
    role: 'Role',
    message: 'Message',
    firstName: 'First Name',
    lastName: 'Last Name',
});

export type OrganizationInvitationFieldsOwnProps = {
    isDisabled: boolean;
};

export type OrganizationInvitationFieldsProps = OrganizationInvitationFieldsOwnProps;

const roles: OrganizationUserRole[] = ['agent', 'admin'];

const selectOptions: SelectOption[] = roles.map((role) => ({
    label: organizationRoles(role),
    value: role,
}));

const OrganizationInvitationFields: React.FC<OrganizationInvitationFieldsProps> = (_props) => {
    return (
        <FormStack>
            <SplitFormRow>
                <Field
                    name="inviteeFirstName"
                    title={intl('firstName')}
                    component={FormikInputs.Input}
                    isRequired
                    validate={required}
                />
                <Field
                    name="inviteeLastName"
                    title={intl('lastName')}
                    component={FormikInputs.Input}
                    isRequired
                    validate={required}
                />
            </SplitFormRow>
            <SplitFormRow>
                <Field
                    name="inviteeEmail"
                    title={intl('email')}
                    component={FormikInputs.Input}
                    isRequired
                    validate={composeValidators(required, email)}
                />
                <Field
                    name="inviteeRole"
                    title={intl('role')}
                    component={FormikInputs.Select}
                    isRequired
                    validate={required}
                    selectOptions={selectOptions}
                />
            </SplitFormRow>
            <Field name="message" title={intl('message')} component={FormikInputs.TextArea} />
        </FormStack>
    );
};

export default React.memo(OrganizationInvitationFields);
